/*
 * User Registration Steps Module
 * @author: Elton Jain
 *
 * @ CHILD_INFO = [{kid_num, gender, dob(YYYY-MM-DD), delivery_place}]
 * SEPERATE USER REGISTRATION MODULE
 */

define('modules/UserRegistration',[
    'jquery',
    'UI',
    'Auth',
    'Config',
    'DatePicker'
], function($, UI, Auth, Config,DatePicker) {
    "use strict";

    var USER_NUM_KIDS = 0, // Number of kids user have
        CHILD_INFO = [], // Info about User's kids
        UserRegistration = {},
        months = ['January','February','March','April','May','June','July','August','September','October','November','December'],
        langs = Config.get('lang');

    /*
     * User Registration process
     *
     * #Steps
     * 1 - Is pregnant
     * 2 - Delivery details
     * 3a - How many kids
     * 3b - Kid details
     * 4 - Category selector
     */
    UserRegistration = {
        _addDatePicker: function(input, direction) {
            input.Zebra_DatePicker({
                direction: (direction) ? [1, 300] : 0,
                onSelect: function(ev) {

                    var base = $(this),
                        dob = base.val(),
                        temp,year,month,day;

                    if(dob) {
                        base.attr('data-value',dob);
                        temp = Date.parse(dob);
                        if(!isNaN(temp)) {
                            temp = new Date(dob);
                            year = temp.getFullYear();
                            month = temp.getMonth() + 1;
                            day = temp.getDate();
                            dob = day + ' ' + months[month - 1] + ', ' + year;
                        }
                    }

                    base.val(dob);
                }
            });
        },
        init: function() {
            var base = this,
                $regStepFld = $('#_regstepinit_');

            // If registration page, init specific step
            // Next steps will initialize when switching screen
            if ($regStepFld.length) {
                this["step" + $regStepFld.val()].init();
            }

            // Track Skip actions
            UI.$b.on('click', '.btn-skip', function(e) {

                var $btn = $(this),
                    $screen = $btn.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name');
                UI.$b.addClass('loading');
                require(['Mixpanel'], function(MixPanel) {
                    MixPanel.hit('user_onboard_steps', {
                        step: step,
                        step_name: step_name,
                        step_action: 'skip'
                    }, function () {
                        UI.$b.removeClass('loading');
                        window.location.href = $btn.attr('href');
                        return true;
                    });
                });
                return false;  
            });

        },
        switchStep: function(currentStep, nextStep) {
            var $currentEl = $('#onboardSteps .step-screen[data-step=' + currentStep + ']'),
                $nextEl = $('#onboardSteps .step-screen[data-step=' + nextStep + ']');

            $currentEl.removeClass('in').addClass('out');
            $nextEl.addClass('in');
            // setTimeout(function() {
            //     // $currentEl.addClass('hidden');
            // }, 500);

            // Temporary
            //$currentEl.hide();
            //$nextEl.show();

            // Init methods for next Step
            this['step' + nextStep].init();
            history.pushState({}, '', this['step' + nextStep].url);
        },
        /*
         * Is pregnant
         */
        step1: {
            form: '.frm-reg-step1',
            api: '/ajax/user/step1/expecting',
            url: '/register-step/1',
            init: function() {
                var base = this;
                UI.$b.on('submit', base.form, function(e) {
                    base.submit(this);
                    return false;
                });
            },
            submit: function(form) {
                var base = this,
                    $form = $(form),
                    $screen = $form.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name');

                UI.$b.addClass('loading');
                $.post(base.api, $(form).serialize(), function(response) {
                    if (response.status === true) {
                        var mxData = {
                            step: step,
                            step_name: step_name,
                            step_action: 'answered',
                            data: {
                                'email': Auth.getUser().email
                            }
                        },
                        userData = window._gtap.data.userData;
                        mxData.data[step_name] = form.isPregnant.value;

                        if (form.isPregnant.value == 0) {
                            UserRegistration.switchStep(1, 3);
                        } else {
                            UserRegistration.switchStep(1, 2);
                            if($('#showHospitalCont').length) {
                                $('#showHospitalCont').addClass('hidden');    
                            }
                        }

                        userData.is_pregnant = parseInt(form.isPregnant.value);

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('user_onboard_steps', mxData);
                        });
                        UI.$b.removeClass('loading');
                    } else {
                        alert('There was some error. Please try again');
                    }

                });
            }
        },

        /*
         * Ask for week pregnant
         */
        step2: {
            form: '#frm-reg-step2',
            api: '/ajax/user/step2/dueDate',
            url: '/register-step/2',
            init: function() {
                var base = this;
                UserRegistration._addDatePicker($('.dob:input'),true);
                UI.$b.on('submit', base.form, function() {
                    base.submit(this);
                    return false;
                });
            },
            
            submit: function(form) {
                var base = this,
                    $form = $(form),
                    $screen = $form.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name');

                require(['Validation'], function (Validation) {
                    var validation = new Validation({
                        form: form,
                        allConstraints: {
                            dueDate: {
                                presence: {
                                    message: '^' + Config.get('lang.due_date')
                                }
                            }
                        }
                    });

                    if (validation.isValid() !== true) {
                        return false;
                    }
                    UI.$b.addClass('loading');
                    $.post(base.api, $(form).serialize(), function(response) {
                        if (response.status === true) {
                            var mxData = {
                                step: step,
                                step_name: step_name,
                                step_action: 'answered',
                                data: {
                                    'email': Auth.getUser().email
                                }
                            };
                            mxData.data[step_name] = form.dueDate.value;

                            require(['Mixpanel'], function(MixPanel) {
                                MixPanel.hit('user_onboard_steps', mxData);
                            });

                            UI.$b.removeClass('loading');
                            UserRegistration.switchStep(2, 4);
                        } else {
                            alert('There was some error. Please try again');
                        }

                    });
                });
            }
        },
        /*
         * Trying to conceive
         */
        step3: {
            form: '.frm-reg-step3',
            api: '/ajax/user/step3/conceive',
            url: '/register-step/3',
            init: function() {
                var base = this;
                UI.$b.on('submit', base.form, function(e) {
                    base.submit(this);
                    return false;
                });
            },
            submit: function(form) {
                var base = this,
                    $form = $(form),
                    $screen = $form.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name');

                UI.$b.addClass('loading');
                $.post(base.api, $(form).serialize(), function(response) {
                    if (response.status === true) {
                        var mxData = {
                            step: step,
                            step_name: step_name,
                            step_action: 'answered',
                            data: {
                                'email': Auth.getUser().email
                            }
                        },
                        userData = window._gtap.data.userData;

                        mxData.data[step_name] = form.isTryingConceive.value;

                        userData.is_trying_conceive = parseInt(form.isTryingConceive.value);

                        if($('#showHospitalCont').length && userData.is_trying_conceive) {
                            $('#visitHospitalCont').removeClass('hidden');
                            $('#showHospitalCont .dropdown').removeClass('hidden');
                        }
                        

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('user_onboard_steps', mxData);
                        });

                        UI.$b.removeClass('loading');
                        UserRegistration.switchStep(3, 4);
                    } else {
                        alert('There was some error. Please try again');
                    }

                });
            }
        },
        /*
         * How many kids
         */
        step4: {
            form: '#frm-reg-step4',
            api: '/ajax/user/step4/children',
            url: '/register-step/4',
            init: function() {
                var base = this;
                UI.$b.on('submit', base.form, function(e) {
                    base.submit(this);
                    return false;
                });

                $(base.form).on('click', 'button', function(ev) {
                    var operation = $(this).data('math'),
                        $parentEl = $(this).parent(),
                        gender = $parentEl.data('content-str'),
                        $contentEl = $parentEl.find('.content'),
                        $inputEl = $parentEl.find('input'),
                        currentCount = parseInt($inputEl.val()),
                        text = '',
                        userData = window._gtap.data.userData,
                        form = $(base.form)[0];

                    // Update current count based on operation    
                    if (operation === 'add') {
                        currentCount++;
                    } else {
                        currentCount--;
                        currentCount = (currentCount < 0) ? 0 : currentCount;
                    }

                    text = currentCount + ' ';

                    if(gender === 'Boy') {
                        if(currentCount === 1) {
                            text += Config.get('lang.number_of_boy');
                        } else {
                            text += Config.get('lang.number_of_boys');
                        }
                    } else {
                        if(currentCount === 1) {
                            text += Config.get('lang.number_of_girl');
                        } else {
                            text += Config.get('lang.number_of_girls');
                        }
                    }

                    $contentEl.text(text);

                    // Update form value
                    $inputEl.val(currentCount);

                    if($('#showHospitalCont').length) {
                        if(parseInt(form.boy.value) > 0 || parseInt(form.girl.value) > 0) {
                            if(!userData.is_pregnant && !userData.is_trying_conceive) {
                                $('#deliverHospitalCont').removeClass('hidden');
                                $('#showHospitalCont .dropdown').removeClass('hidden');
                            }
                        } else {
                            if(!userData.is_pregnant && !userData.is_trying_conceive) {
                                $('#deliverHospitalCont').addClass('hidden');
                                $('#showHospitalCont .dropdown').addClass('hidden');
                            }
                        }    
                    }

                    

                });
            },
            submit: function(form) {
                var base = this,
                    $form = $(form),
                    $screen = $form.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name'),
                    userData = window._gtap.data.userData;

                UI.$b.addClass('loading');
                $.post(base.api, $form.serialize(), function(response) {
                    if (response.status === true) {
                        var mxData = {
                            step: step,
                            step_name: step_name,
                            step_action: 'answered',
                            data: {
                                'num_boys': form.boy.value,
                                'num_girls': form.girl.value,
                                'email': Auth.getUser().email
                            }
                        };

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('user_onboard_steps', mxData, function () {
                                UI.$b.removeClass('loading');
                                if(!userData.is_pregnant && (parseInt(form.boy.value) > 0 || parseInt(form.girl.value) > 0)) {
                                    UI.$b.removeClass('loading');
                                    window._gtap.data.userData.num_kids = parseInt(form.boy.value) + parseInt(form.girl.value);
                                    var msg = (userData.num_kids == 1) ? langs.err_enter_child_dob : langs.add_younger_kid_dob_title;
                                    $('#frm-reg-step5').siblings('.sec-heading').text(msg);
                                    UserRegistration.switchStep(4, 5);
                                } else {
                                    window.location.href = $form.attr('action');    
                                }
                                
                                return true;
                            });
                        });

                    } else {
                        alert('There was some error. Please try again');
                    }

                });
            }
        },

        step5: {
            form: '#frm-reg-step5',
            api: '/ajax/user/step5/smallestDob',
            url: '/register-step/5',
            init: function() {
                var base = this;
                UserRegistration._addDatePicker($('.dob:input'));
                UI.$b.on('submit', base.form, function() {
                    base.submit(this);
                    return false;
                });
            },
            
            submit: function(form) {
                var base = this,
                    $form = $(form),
                    $screen = $form.parents('.step-screen'),
                    step = $screen.data('step'),
                    step_name = $screen.data('step-name');

                require(['Validation'], function (Validation) {
                    var validation = new Validation({
                        form: form,
                        allConstraints: {
                            smallestDob: {
                                presence: {
                                    message: '^' + Config.get('lang.err_birthday')
                                }
                            }
                        }
                    });

                    if (validation.isValid() !== true) {
                        return false;
                    }
                    UI.$b.addClass('loading');
                    $.post(base.api, $(form).serialize(), function(response) {
                        if (response.status === true) {
                            var mxData = {
                                step: step,
                                step_name: step_name,
                                step_action: 'smallestDob',
                                data: {
                                    'email': Auth.getUser().email
                                }
                            };
                            mxData.data[step_name] = form.smallestDob.value;

                            require(['Mixpanel'], function(MixPanel) {
                                MixPanel.hit('user_onboard_steps', mxData, function() {
                                    window.location.href = $form.attr('action');
                                    return false;
                                });
                            });

                            UI.$b.removeClass('loading');

                        } else {
                            alert('There was some error. Please try again');
                        }

                    });
                });
            }
        },
        /*
         * Saving Categories
         */
        step6: {
            form: '#frm-reg-cat-chooser',
            api: '/ajax/user/step6/category/groups',
            url: '/register-step/6',
            selectedCount: 0,

            $btnSubmit: $('#btn-submit-reg-cat'),

            init: function() {
                var base = this,
                    $form = $(base.form);
                base.selectedCount = -1 * $form.find('input:checked').length;
                base.onChange();

                UI.$b.on('click', 'label', function(ev) {
                    if ($(ev.target).is('input')) {
                        $(this).closest('li').toggleClass('selected');
                        var $item = $(this),
                            $checkbox = $item.find('input');

                        if ($checkbox.prop('checked')) {
                            base.selectedCount--;
                        } else {
                            base.selectedCount++;
                        }
                        base.onChange();
                    }
                });

                UI.$b.on('click', '.expand-list', function() {
                    var allLi = $(this).siblings().not('.visible');
                    if ($(this).hasClass('collapse')) {
                        allLi.slideDown('500');
                        //$(this).removeClass('collapse').addClass('expand');
                    } else {
                        allLi.slideUp('500');
                        //$(this).removeClass('expand').addClass('collapse');
                    }

                    $(this).toggleClass('collapse expand');

                });


                UI.$b.on('submit', base.form, function() {
                    // Validate
                    if ($(this).find('input:checked').length < 3) {
                        alert('Please select atleast 3 categories');
                        return false;
                    }

                    base.submit(this);
                    return false;
                });
            },
            onChange: function() {
                var c = this.selectedCount,
                    selectedCount = $(this.form).find('input:checked').length;

                if (selectedCount < 3) {
                    var text = "";
                    if(selectedCount == 1) {
                        this.$btnSubmit.val(Config.get('lang.two_more'));
                    } else if(selectedCount == 2) {
                        this.$btnSubmit.val(Config.get('lang.one_more'));
                    } else {
                        this.$btnSubmit.val(Config.get('lang.select_three'));
                    }
                    //this.$btnSubmit.val("Select " + (3 + c) + " more " + (c == -2 ? 'group ' : 'groups'));
                    this.$btnSubmit.addClass('disabled');
                } else {
                    this.$btnSubmit.val(Config.get('lang.good_to_go'));
                    this.$btnSubmit.removeClass('disabled');
                }
            },
            show: function() {
                // Require reload instead of switching screen
                window.location.href = this.url;
            },
            submit: function(form) {
                var base = this,
                    ajaxData = {};

                ajaxData = $(form).serialize();
                UI.$b.addClass('loading');

                $.post(base.api, ajaxData, function(response) {
                    if (response.status === true) {
                        var mxData = {
                            step: 5,
                                step_name: 'select_topics',
                                step_action: 'answered',
                                data: {
                                    'email': Auth.getUser().email
                                }
                            };

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('onboarding_complete');
                            MixPanel.hit('user_onboard_steps', mxData, function () {
                                UI.$b.removeClass('loading');
                                if (response.redirect_url) {
                                    window.location.href = response.redirect_url;
                                } else {
                                    window.location.href = '/';
                                }
                                return true;
                            });
                        });

                    } else {
                        alert(response.message);
                    }

                });
            }
        }
    };

    UserRegistration.init();

    return UserRegistration;
});
